module.exports = __webpack_public_path__ + "static/media/herrin.18bb21a7.jpg";